import DraggableButton from "./DraggableButton";
import DraggableContainer from "./DraggableContainer";
import DraggableDiv from "./DraggableDiv";
import DraggableForm from "./DraggableForm";
import DraggableGrid from "./DraggableGrid";
import DraggableGridItem from "./DraggableGridItem";
import DraggableImage from "./DraggableImage";
import DraggableLink from "./DraggableLink";
import DraggableList from "./DraggableList";
import DraggableSvg from "./DraggableSvg";
import DraggableText from "./DraggableText";
import DraggableTitle from "./DraggableTitle";
import DraggableListItem from "./DraggableListItem";
import DraggableNavbarHorizontal from "./DraggableNavbarHorizontal";
import DraggableNavbarVertical from "./DraggableNavbarVertical";
import DraggableIcon from "./DraggableIcon";
import DraggableHtml from "./DraggableHtml";
import DraggableImageSlider from "./DraggableImageSlider";
import { DraggableComponentTypes } from "../../../types/draggable";
import DraggableRepeatableSlider from "./repeatable/DraggableRepeatableSlider";
import DraggableRepeatableGrid from "./repeatable/DraggableRepeatableGrid";
import DraggableAccordion from "./DraggableAccordion";
export default {
    [DraggableComponentTypes.Div]: DraggableDiv,
    [DraggableComponentTypes.Button]: DraggableButton,
    [DraggableComponentTypes.Container]: DraggableContainer,
    [DraggableComponentTypes.Form]: DraggableForm,
    [DraggableComponentTypes.Grid]: DraggableGrid,
    [DraggableComponentTypes.GridItem]: DraggableGridItem,
    [DraggableComponentTypes.Image]: DraggableImage,
    [DraggableComponentTypes.Link]: DraggableLink,
    [DraggableComponentTypes.List]: DraggableList,
    [DraggableComponentTypes.Svg]: DraggableSvg,
    [DraggableComponentTypes.Text]: DraggableText,
    [DraggableComponentTypes.Title]: DraggableTitle,
    [DraggableComponentTypes.ListItem]: DraggableListItem,
    [DraggableComponentTypes.Navbar]: DraggableNavbarHorizontal,
    [DraggableComponentTypes.NavbarVertical]: DraggableNavbarVertical,
    [DraggableComponentTypes.Icon]: DraggableIcon,
    [DraggableComponentTypes.Html]: DraggableHtml,
    [DraggableComponentTypes.ImageSlider]: DraggableImageSlider,
    [DraggableComponentTypes.RepeatableSlider]: DraggableRepeatableSlider,
    [DraggableComponentTypes.RepeatableGrid]: DraggableRepeatableGrid,
    [DraggableComponentTypes.Accordion]: DraggableAccordion,
};
//# sourceMappingURL=index.js.map